import type { GnomuxSequence } from "@db/content";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { formatBp } from "@lib/genetics";
import { cn } from "@lib/styling";
import { GripVerticalIcon } from "lucide-react";

type SortableSequenceItemProps = {
  sequence: GnomuxSequence;
};

export function SortableSequenceItem({ sequence }: SortableSequenceItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: sequence.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        "flex min-w-0 items-center gap-2 rounded-sm p-1.5",
        isDragging && "z-10 opacity-50",
      )}
    >
      <button
        type="button"
        className="shrink-0 cursor-grab text-muted-foreground"
        {...attributes}
        {...listeners}
      >
        <GripVerticalIcon className="size-4" />
      </button>
      <span className="min-w-0 flex-1 truncate text-sm">{sequence.name}</span>
      <span className="shrink-0 text-muted-foreground text-xs">
        {formatBp(sequence.length)}
      </span>
    </div>
  );
}
